import { FC, useEffect } from "react";
import { State } from "../../../redux/slices";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { ThunkDispatch } from "@reduxjs/toolkit";
import {
  CreateUsersStep,
  setCreateUsersStep,
} from "../../../redux/slices/users/createUsers";
import { CheckExpiredToken } from "../../../utils/authentication";
import { SetActionsLayout } from "../../layout/Layout";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();

  return {
    setSteps: (value: CreateUsersStep) => {
      dispatch(setCreateUsersStep(value));
    },
  };
};

export const StepZero: FC<any> = () => {
  const [t] = useTranslation("global");

  const { setSteps } = SetActions();
  const { logoutClickHandler } = SetActionsLayout();
  
  const { createUserSteps } = useSelector(
    (state: State) => state.CreateUsersReducer
  );
  const { user } = useSelector((state: State) => state.Authentication);

  useEffect(() => {
    CheckExpiredToken(logoutClickHandler, user);
  }, []);

  return (
    <div className="create-sites-container-steps">
      <div className="title-step-zero">{t("Users_add_users.type")}</div>
      <div
        className="div-cards-step-zero"
        onClick={() => setSteps({ ...createUserSteps, step: 1, option: "a" })}
        aria-hidden
      >
        <Card
          sx={{
            display: "flex",
            minWidth: 25,
            justifyContent: "space-between",
            marginTop: "24px",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <CardContent sx={{ flexDirection: "column" }}>
              <Typography
                component="div"
                sx={{
                  fontSize: "20px",
                }}
              >
                {t("Users_add_users.site_user")}
              </Typography>
              <Typography
                variant="subtitle1"
                component="div"
                sx={{
                  color: "text.secondary",
                  fontSize: "14px",
                }}
              >
                {t("Users_add_users.site_sub")}
              </Typography>
            </CardContent>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ChevronRightIcon />
          </Box>
        </Card>
      </div>

      <div
        className="div-cards-step-zero"
        onClick={() => setSteps({ ...createUserSteps, step: 1, option: "b" })}
        aria-hidden
      >
        <Card
          sx={{
            display: "flex",
            minWidth: 25,
            justifyContent: "space-between",
            marginTop: "24px",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <CardContent sx={{ flex: "1 0 auto" }}>
              <Typography
                component="div"
                sx={{
                  fontSize: "20px",
                }}
              >
                {t("Users_add_users.manager_user")}
              </Typography>
              <Typography
                variant="subtitle1"
                component="div"
                sx={{ color: "text.secondary", fontSize: "14px" }}
              ></Typography>
            </CardContent>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <ChevronRightIcon />
          </Box>
        </Card>
      </div>
      <div className="background-components-fix" />
    </div>
  );
};
